import { PropsWithChildren } from 'react';

import { useQuery } from '@apollo/client/react';
import { css } from '@emotion/react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ClubLogo } from '@scorenco/components';
import { useRouter } from 'next/router';

import { Clock } from '../../components/Clock';
import { pickTextColorBasedOnBgColorSimple } from '../../utils';

import { ResolutionWarning } from './ResolutionWarning';
import { ScreenLayoutGetClubHouseDocument } from './ScreenLayout.query.generated';

export const ScreenLayoutComponent = ({
  children,
  ...rest
}: PropsWithChildren) => {
  const router = useRouter();
  const getClubHouseQuery = useQuery(ScreenLayoutGetClubHouseDocument, {
    variables: {
      clubhouseId: Number(router.query.clubhouseId),
    },
    context: {
      role: 'anonymous',
    },
  });
  const clubHouse = getClubHouseQuery.data?.clubhouse_club_house_by_pk;

  if (!clubHouse) {
    if (getClubHouseQuery.loading) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100vh"
        >
          <Typography variant="h2">Chargement ...</Typography>
        </Box>
      );
    }

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Typography>
          Une erreur s'est produite, veuillez réessayer ou nous contacter
        </Typography>
      </Box>
    );
  }

  return (
    <ResolutionWarning>
      <Box
        css={[
          css`
            height: 100vh;
            overflow: hidden;

            /* Augmentation tailles éléments */

            .event-card_team-container {
              width: 24% !important;
            }

            .event-card_team {
              font-size: 1.3rem !important;
              font-weight: bolder;
              width: 180% !important;
            }
            .event-card_header_text {
              font-size: 1.2rem !important;
            }

            .event-card_date .date {
              font-size: 1.2rem !important;
            }
            .event-card_date .time {
              font-size: 1rem !important;
            }

            .event-item_team {
              font-size: 1.15rem !important;
              font-weight: bolder;
            }
            .event-item_date > *:first-of-type {
              font-size: 1.1rem !important;
            }
            .event-item_date {
              font-size: 1rem !important;
            }
            .competition-ranking-row {
              .cell {
                font-size: 1.1rem !important;
              }
              .team {
                margin-left: 0.5rem !important;
                font-size: 1.4rem !important;
                font-weight: bolder;
                .logo {
                  width: 1.5rem;
                  height: auto;
                  margin-right: 1rem;
                }
              }
            }
          `,
          clubHouse?.club?.color_primary &&
            css`
              --snc-palette-secondary-main: ${clubHouse?.club.color_primary};
              --snc-palette-secondary-contrastText: ${pickTextColorBasedOnBgColorSimple(
                clubHouse?.club.color_primary,
                '#ffffff',
                '#000000'
              )};
            `,
        ]}
        {...rest}
      >
        <Box
          css={(theme) => css`
            background: ${theme.vars.palette.secondary.main};
            color: ${theme.vars.palette.secondary.contrastText};
            height: 5rem;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 2rem;
            padding-left: 1rem;
          `}
        >
          <ClubLogo
            logo={
              clubHouse?.tournament_logo?.[0]?.tournament?.logo ||
              clubHouse?.tournament_logo?.[0]?.challenge?.tournament?.logo ||
              clubHouse?.tournament_logo?.[0]?.phase?.rule?.challenge
                ?.tournament?.logo ||
              clubHouse?.club?.logo
            }
            css={css`
              margin-top: 12rem;
              width: 15.5rem;
              height: 15.5rem;
              z-index: 8;
            `}
            width={250}
            height={250}
          />

          <Clock />
        </Box>

        {clubHouse && children}
      </Box>
    </ResolutionWarning>
  );
};
